














import Vue from "vue";
import iwInputNumber from "@/encoding/components/buildingBlocks/InputNumber.vue";

export default Vue.extend({

    components: {
        iwInputNumber: iwInputNumber
    },
    data: function() {
        return {
            pathInStore: "property.livingRoom.surface",
        };
    },
    computed: {
        floorAreaLivingRoom: function(): string|null {
            return this.$store.getters["FormModule/getValue"](this.pathInStore) ?? "";
        },
        hasLivingRoom: function(): boolean {
            return this.$store.getters["FormModule/getValue"]("property.livingRoom.exists");
        }
    },
    methods: {
        updateValue: function(floorAreaLivingRoom: number): void {
            if (!this.hasLivingRoom || (floorAreaLivingRoom == 0 && this.floorAreaLivingRoom != null)) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": floorAreaLivingRoom});
            }
        }
    }
});

